module.exports = __webpack_public_path__ + "img/arrow_right.d8a4e35e.svg";